import { Plus } from 'assets/Icons'
import { Fragment } from 'react'
import { useNavigate } from 'react-router-dom'

const Header = ({ role }) => {
	const navigate = useNavigate()
	return (
		<div className='mb-5'>
			<div className='flex items-center justify-between mb-3'>
				<h1 className='text-[#292A32] dark:text-[#FFFFFF] text-[18px] lg:text-[24px] font-semibold'>
					Guruhlar
				</h1>
				{role === 'admin' && (
					<Fragment>
						<span className='inline-block md:hidden'>
							<button
								className='border-none outline-none'
								onClick={() => navigate('/account/groups/create')}
							>
								<Plus
									classname={'size-[24px] text-[#292A32] dark:text-[#FFFFFF]'}
								/>
							</button>
						</span>
						<span className='hidden md:flex'>
							<button
								className='success-btn'
								onClick={() => navigate('/account/groups/create')}
							>
								Yangi guruh yaratish
							</button>
						</span>
					</Fragment>
				)}
			</div>
		</div>
	)
}

export default Header
